import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import asyncComponent from '../../util/AsyncFunc';

import AddResolution from './addresolution/index'
import ResolutionList from './resolutionlist/index'

//auth
import {
    userIsAuthenticatedRedir, userIsNotAuthenticatedRedir,
    userIsAuthenticated, userIsNotAuthenticated, userIsSuperAdminRedir,
    userIsBoardAdminRedir, userIsCommitteeAdminRedir, userIsCheckerAdminRedir
} from '../auth'

const AddResolutionProtected_ma = userIsCommitteeAdminRedir(AddResolution)
const ResolutionListProtected_ma = userIsCommitteeAdminRedir(ResolutionList)

const Resolution = ({ match }) => (
    <div className="app-wrapper">
        <Switch>
            {/* Resolution Admin */}
            <Redirect exact from={`${match.url}/`} to={`${match.url}/resolution-list`} />
            <Route path={`${match.url}/add-resolution/:id?`} component={AddResolutionProtected_ma} />
            <Route path={`${match.url}/resolution-list/:id?`} component={ResolutionListProtected_ma} />
        </Switch>
    </div>
);

export default Resolution;



// WEBPACK FOOTER //
// ./app/resolutiondetails/index.js